(function () {
  function handleEstimatedSpendSelected() {
    const hiddenClass = 'is-hidden';
    const id = this.id;
    const spendNoticeElUnder = document.querySelector('.js-spend-notice');
    const spendNoticeElOver = document.querySelector('.js-spend-notice-over');
    const parentEl = this.parentElement;
    const warningClass = 'radio-selection__radio--warning';

    const spendNoticeMarkupUnder = `
    <div class="info-block info-block--alert js-spend-notice">
    <div class="info-block__icon">
        <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.667 11c0 5.892-4.776 10.667-10.667 10.667C5.11 21.667.333 16.892.333 11 .333 5.111 5.11.333 11 .333 16.89.333 21.667 5.111 21.667 11zM11 13.15a1.979 1.979 0 100 3.958 1.979 1.979 0 000-3.957zM9.122 6.04l.319 5.85a.516.516 0 00.515.487h2.088c.274 0 .5-.214.515-.488l.32-5.85a.516.516 0 00-.516-.543H9.637a.516.516 0 00-.515.544z" fill="currentColor" fill-rule="evenodd"></path>
        </svg>  </div>
        <div class="info-block__text">
            <h3>With an annual spend of below £1000, we suggest you order using our Garden Superstore retail website. <a href="https://www.thegardensuperstore.co.uk/general/fargro" target="_blank">www.thegardensuperstore.co.uk</a></h3><p>However, if you prefer, you can still continue your Fargro
            Trade Account application.</p>
        </div>
    </div>
    `;

    const spendNoticeMarkupOver = `
    <div class="info-block info-block--alert js-spend-notice-over">
    <div class="info-block__icon">
        <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.667 11c0 5.892-4.776 10.667-10.667 10.667C5.11 21.667.333 16.892.333 11 .333 5.111 5.11.333 11 .333 16.89.333 21.667 5.111 21.667 11zM11 13.15a1.979 1.979 0 100 3.958 1.979 1.979 0 000-3.957zM9.122 6.04l.319 5.85a.516.516 0 00.515.487h2.088c.274 0 .5-.214.515-.488l.32-5.85a.516.516 0 00-.516-.543H9.637a.516.516 0 00-.515.544z" fill="currentColor" fill-rule="evenodd"></path>
        </svg>  </div>
        <div class="info-block__text">
            <h3>By selecting this option you confirm that you anticipate spending £1000 or more during the next calendar year and agree to spending a minimum of £250 Excl. VAT on your first order.</h3>
            <p>Additional delivery charges may occur if we are unable to gain appropriate access. For delivery information please <a href="/delivery-and-returns">click here</a></p>
        </div>
    </div>
    `;

    if (id === 'under500') {
      if (!spendNoticeElUnder) {
        parentEl.insertAdjacentHTML('afterend', spendNoticeMarkupUnder);
        parentEl.classList.add(warningClass);
        if (spendNoticeElOver) {
          spendNoticeElOver.remove();
        }
      }
    } else if (id === 'over500') {
      if (!spendNoticeElOver) {
        parentEl.insertAdjacentHTML('afterend', spendNoticeMarkupOver);
        parentEl.classList.add(warningClass);
        if (spendNoticeElUnder) {
          spendNoticeElUnder.remove();
        }
      }
    } else {
      parentEl.classList.remove(warningClass);
      if (spendNoticeElUnder) {
        spendNoticeElUnder.remove();
      }
      if (spendNoticeElOver) {
        spendNoticeElOver.remove();
      }
    }
  }

  const estimatedSpendEls = document.querySelectorAll('input[name="estimatedSpend"]');

  estimatedSpendEls.forEach((option) => {
    option.addEventListener('click', handleEstimatedSpendSelected);
  });
})();
